import { render, staticRenderFns } from "./pswpUI.vue?vue&type=template&id=31a3cfca&"
import script from "./pswpUI.vue?vue&type=script&lang=ts&"
export * from "./pswpUI.vue?vue&type=script&lang=ts&"
import style0 from "./pswpUI.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports